<form [formGroup]="form.formGroup">
  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0">Composition %</p-tab>
      <p-tab value="1">Options</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">

        <p-toolbar>
          <ng-template #start></ng-template>
          <ng-template #end>
            <div class="flex items-center">
              <svg-icon
                src="../../assets/icons/reset-default-24x24.svg"
                class="w-[25px] h-[25px] tree-icon cursor-pointer"
                (click)="applyDefaults()"
                title="Apply Defaults">
              </svg-icon>
            </div>
          </ng-template>
        </p-toolbar>

        <div class="flex">
          <div class="flex flex-col w-1/2 space-y-2 p-2">
            <div class="flex flex-col">
              <label for="c1">C<span class="text-sm align-sub">1</span></label>
              <app-validated-number-input
                [id]="'c1'"
                [control]="control('c1')"
                [value]="control('c1').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                (onChange)="calculateTotalPercent('c1', $event)"
              ></app-validated-number-input>
            </div>

            <div class="flex flex-col">
              <label for="c2">C<span class="text-sm align-sub">2</span></label>
              <app-validated-number-input
                [id]="'c2'"
                [control]="control('c2')"
                [value]="control('c2').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                (onChange)="calculateTotalPercent('c2', $event)"
              ></app-validated-number-input>
            </div>

            <div class="flex flex-col">
              <label for="c3">C<span class="text-sm align-sub">3</span></label>
              <app-validated-number-input
                [id]="'c3'"
                [control]="control('c3')"
                [value]="control('c3').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                (onChange)="calculateTotalPercent('c3', $event)"
              ></app-validated-number-input>
            </div>

            <div class="flex flex-col">
              <label for="nC4">nC<span class="text-sm align-sub">4</span></label>
              <app-validated-number-input
                [id]="'nC4'"
                [control]="control('nC4')"
                [value]="control('nC4').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                (onChange)="calculateTotalPercent('nC4', $event)"
              ></app-validated-number-input>
            </div>

            <div class="flex flex-col">
              <label for="iC4">iC<span class="text-sm align-sub">4</span></label>
              <app-validated-number-input
                [id]="'iC4'"
                [control]="control('iC4')"
                [value]="control('iC4').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                (onChange)="calculateTotalPercent('iC4', $event)"
              ></app-validated-number-input>
            </div>

            <div class="flex flex-col">
              <label for="nC5">nC<span class="text-sm align-sub">5</span></label>
              <app-validated-number-input
                [id]="'nC5'"
                [control]="control('nC5')"
                [value]="control('nC5').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                (onChange)="calculateTotalPercent('nC5', $event)"
              ></app-validated-number-input>
            </div>
          </div>

          <div class="flex flex-col w-1/2 space-y-2 p-2">
            <div class="flex flex-col">
              <label for="iC5">iC<span class="text-sm align-sub">5</span></label>
              <app-validated-number-input
                [id]="'iC5'"
                [control]="control('iC5')"
                [value]="control('iC5').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                (onChange)="calculateTotalPercent('iC5', $event)"
              ></app-validated-number-input>
            </div>

            <div class="flex flex-col">
              <label for="nC6">nC<span class="text-sm align-sub">6</span></label>
              <app-validated-number-input
                [id]="'nC6'"
                [control]="control('nC6')"
                [value]="control('nC6').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                (onChange)="calculateTotalPercent('nC6', $event)"
              ></app-validated-number-input>
            </div>

            <div class="flex flex-col">
              <label for="n2">N<span class="text-sm align-sub">2</span></label>
              <app-validated-number-input
                [id]="'n2'"
                [control]="control('n2')"
                [value]="control('n2').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                (onChange)="calculateTotalPercent('n2', $event)"
              ></app-validated-number-input>
            </div>

            <div class="flex flex-col">
              <label for="cO2">CO<span class="text-sm align-sub">2</span></label>
              <app-validated-number-input
                [id]="'cO2'"
                [control]="control('cO2')"
                [value]="control('cO2').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                (onChange)="calculateTotalPercent('cO2', $event)"
              ></app-validated-number-input>
            </div>

            <div class="flex flex-col">
              <label for="h2S">H<span class="text-sm align-sub">2</span>S</label>
              <app-validated-number-input
                [id]="'h2S'"
                [control]="control('h2S')"
                [value]="control('h2S').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                (onChange)="calculateTotalPercent('h2S', $event)"
              ></app-validated-number-input>
            </div>

            <div class="flex flex-col">
              <label for="h2O">H<span class="text-sm align-sub">2</span>O</label>
              <app-validated-number-input
                [id]="'h2O'"
                [control]="control('h2O')"
                [value]="control('h2O').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                (onChange)="calculateTotalPercent('h2O', $event)"
              ></app-validated-number-input>
            </div>

            <p class="{{ totalError ? 'validation-error' : '' }}">Total: {{ totalPercent }} %</p>
            @if (totalError) {
              <p class="validation-error">Total must be equal to 100% ({{ percentLabel }}: {{ difference }} %)</p>
            }
          </div>
        </div>

        <p-fieldset legend="VLE Heavy Weight Hydrocarbons (maximum of three)">
          <app-heavies
            [formControlName]="form.formControlNames.vleHeavyWeightHydrocarbonComponents"
            (onInput)="calculateTotalPercent(null, null)">
          </app-heavies>
        </p-fieldset>

      </p-tabpanel>

      <p-tabpanel value="1">
        <app-vle-tuning-parameters [formControlName]="form.formControlNames.vleTuningParameters">
        </app-vle-tuning-parameters>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</form>
